import { render } from "./riwayat.vue?vue&type=template&id=73113033&scoped=true"
import script from "./riwayat.vue?vue&type=script&lang=js"
export * from "./riwayat.vue?vue&type=script&lang=js"

import "./riwayat.vue?vue&type=style&index=0&id=73113033&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73113033"]])

export default __exports__